const $ = jQuery;
import 'bootstrap/js/dist/popover';
const template = `
    <div role="tooltip"  class="popover-dismissible popover-info popover bs-popover-bottom">
        <div class="arrow"></div>
        <div class="popover-body"></div>
    </div>`;

function setup() {
	let allowClose = false;
	const target = $( '#wp-admin-bar-lock-status' );
	if ( ! target || ! target.children()[ 0 ] ) {
		return;
	}
	const linkToPlatform = target.children()[ 0 ].title;
	const content = () => {
		return `
            <div class="popover-details">
                <div class="popover-text-wrapper">
                <div>When Site Lock is on, search engines won’t display your site, and visitors can only access it with a code.</div>
                </div>
                <button type="button" id="closeButton" class="popover-close"><i class="icon icon-close"> <svg class="icon-src" viewBox="0 0 512 512"><path fill="currentColor" fill-rule="evenodd" d="M298.4326 256.0063l128.204-128.204 26.4383-26.4384c3.9001-3.9001 3.9001-10.2378 0-14.138l-28.2884-28.2883c-3.9001-3.9001-10.2378-3.9001-14.138 0L256.0064 213.5799 101.3639 58.9251c-3.9001-3.9001-10.2378-3.9001-14.138 0L58.9252 87.2135c-3.9001 3.9001-3.9001 10.2378 0 14.138l154.6548 154.6548L58.9251 410.6486c-3.9001 3.9001-3.9001 10.2378 0 14.138l28.2884 28.2883c3.9001 3.9001 10.2378 3.9001 14.138 0l154.6548-154.6423 128.204 128.204 26.4383 26.4383c3.9001 3.9001 10.2378 3.9001 14.138 0l28.2883-28.2884c3.9001-3.9001 3.9001-10.2378 0-14.138L298.4326 256.0064z"></path></svg></i>
                </button>
            </div>
            <div class="popover-cta"><a id="changeThisLink" target="_blank" href="${ linkToPlatform }">Change this setting</a></div>`;
	};
	// Show it:
	target.popover( {
		placement: 'bottom',
		content,
		template,
		html: true,
		container: 'body',
		trigger: 'click',
		sanitize: false,
		boundary: 'window',
	} );
	// User pressed on "X"
	target.on( 'shown.bs.popover', () => {
		$( '#closeButton' ).on( 'click', () => {
			allowClose = true;
			target.popover( 'hide' );
		} );
	} );
	// Otherwise leave it open
	target.on( 'hide.bs.popover', ( e ) => {
		if ( ! allowClose ) {
			e.preventDefault();
		} else {
			allowClose = false;
		}
	} );
}

const ready = ( callback ) => {
	if ( 'loading' !== document.readyState ) {
		callback();
	} else {
		document.addEventListener( 'DOMContentLoaded', callback );
	}
};

ready( setup );
